import script from "./AiChatPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./AiChatPanel.vue?vue&type=script&setup=true&lang=js"

import "./AiChatPanel.vue?vue&type=style&index=0&id=3c1be9d7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c1be9d7"]])

export default __exports__